module.exports = __webpack_public_path__ + "static/media/buy_req_rent_1.43a61b55.jpg";